import { render, staticRenderFns } from "./InventoryActivity.vue?vue&type=template&id=e351b78a&scoped=true"
import script from "./InventoryActivity.vue?vue&type=script&lang=js"
export * from "./InventoryActivity.vue?vue&type=script&lang=js"
import style0 from "./InventoryActivity.vue?vue&type=style&index=0&id=e351b78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e351b78a",
  null
  
)

export default component.exports